/* eslint-disable import/prefer-default-export */
import React from 'react';

const PhoneFR = (props) => (
  <svg viewBox="0 0 318.6 656.2" {...props}>
    <title>NutriGuide interface example presented on a phone</title>
    <path
      d="M46.4 0h225.8c25.6 0 46.4 20.8 46.4 46.4v563.5c0 25.6-20.8 46.4-46.4 46.4H46.4C20.8 656.2 0 635.4 0 609.8V46.4C0 20.8 20.8 0 46.4 0z"
      fill="#ebebeb"
    />
    <defs>
      <path
        id="prefix__a"
        d="M46.4 0h225.8c25.6 0 46.4 20.8 46.4 46.4v563.5c0 25.6-20.8 46.4-46.4 46.4H46.4C20.8 656.2 0 635.4 0 609.8V46.4C0 20.8 20.8 0 46.4 0z"
      />
    </defs>
    <clipPath id="prefix__b">
      <use xlinkHref="#prefix__a" overflow="visible" />
    </clipPath>
    <g clipPath="url(#prefix__b)">
      <path fill="#ebebeb" d="M-61.8-61.8h442.2V718H-61.8z" />
      <defs>
        <path id="prefix__c" d="M-61.8-61.8h442.2V718H-61.8z" />
      </defs>
      <clipPath id="prefix__d">
        <use xlinkHref="#prefix__c" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__d)">
        <path fill="#ebebeb" d="M-1.3-1.3h321.1v658.8H-1.3z" />
      </g>
    </g>
    <path
      d="M45.3 14.4h227.9c17.1 0 30.9 13.8 30.9 30.9v565.5c0 17.1-13.8 30.9-30.9 30.9H45.3c-17.1 0-30.9-13.8-30.9-30.9V45.3c0-17 13.9-30.9 30.9-30.9z"
      fill="#fff"
    />
    <defs>
      <path
        id="prefix__e"
        d="M45.3 14.4h227.9c17.1 0 30.9 13.8 30.9 30.9v565.5c0 17.1-13.8 30.9-30.9 30.9H45.3c-17.1 0-30.9-13.8-30.9-30.9V45.3c0-17 13.9-30.9 30.9-30.9z"
      />
    </defs>
    <clipPath id="prefix__f">
      <use xlinkHref="#prefix__e" overflow="visible" />
    </clipPath>
    <g clipPath="url(#prefix__f)">
      <path fill="#fff" d="M-61.8-61.8h442.2V718H-61.8z" />
      <defs>
        <path id="prefix__g" d="M-61.8-61.8h442.2V718H-61.8z" />
      </defs>
      <clipPath id="prefix__h">
        <use xlinkHref="#prefix__g" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__h)">
        <path fill="#fff" d="M13.1 13.1h292.3V643H13.1z" />
        <defs>
          <path id="prefix__i" d="M13.1 13.1h292.3V643H13.1z" />
        </defs>
        <clipPath id="prefix__j">
          <use xlinkHref="#prefix__i" overflow="visible" />
        </clipPath>
        <g clipPath="url(#prefix__j)">
          <path fill="#fff" d="M14.4 14.4h289.7v627.3H14.4z" />
          <defs>
            <path id="prefix__k" d="M14.4 14.4h289.7v627.3H14.4z" />
          </defs>
          <clipPath id="prefix__l">
            <use xlinkHref="#prefix__k" overflow="visible" />
          </clipPath>
          <g clipPath="url(#prefix__l)">
            <path fill="#fff" d="M13.1 13.1h292.3V643H13.1z" />
          </g>
        </g>
      </g>
    </g>
    <path
      d="M81.4 13.9h156.1V19c0 9.7-7.8 17.5-17.5 17.5H99c-9.7 0-17.5-7.8-17.5-17.5l-.1-5.1z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#ebebeb"
    />
    <defs>
      <path
        id="prefix__m"
        d="M81.4 13.9h156.1V19c0 9.7-7.8 17.5-17.5 17.5H99c-9.7 0-17.5-7.8-17.5-17.5l-.1-5.1z"
      />
    </defs>
    <clipPath id="prefix__n">
      <use xlinkHref="#prefix__m" overflow="visible" />
    </clipPath>
    <g clipPath="url(#prefix__n)">
      <path fill="#ebebeb" d="M-61.8-61.8h442.2V718H-61.8z" />
      <defs>
        <path id="prefix__o" d="M-61.8-61.8h442.2V718H-61.8z" />
      </defs>
      <clipPath id="prefix__p">
        <use xlinkHref="#prefix__o" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__p)">
        <path fill="#ebebeb" d="M80.1 12.6h158.6v25.2H80.1z" />
      </g>
    </g>
    <defs>
      <path id="prefix__q" d="M749-7.2h358.7v696.4H749z" />
    </defs>
    <clipPath id="prefix__r">
      <use xlinkHref="#prefix__q" overflow="visible" />
    </clipPath>
    <g clipPath="url(#prefix__r)">
      <path
        d="M98 0h225.8c25.6 0 46.4 20.8 46.4 46.4v563.5c0 25.6-20.8 46.4-46.4 46.4H98c-25.6 0-46.4-20.8-46.4-46.4V46.4C51.6 20.8 72.4 0 98 0z"
        fill="#fff"
      />
    </g>
    <defs>
      <path id="prefix__s" d="M761.9-5.2h333v670.6h-333z" />
    </defs>
    <clipPath id="prefix__t">
      <use xlinkHref="#prefix__s" overflow="visible" />
    </clipPath>
    <g clipPath="url(#prefix__t)">
      <path
        d="M149.5 0h225.8c25.6 0 46.4 20.8 46.4 46.4v563.5c0 25.6-20.8 46.4-46.4 46.4H149.5c-25.6 0-46.4-20.8-46.4-46.4V46.4c0-25.6 20.8-46.4 46.4-46.4z"
        fill="#fff"
      />
    </g>
    <defs>
      <path
        id="prefix__u"
        d="M815.5 0h225.8c25.6 0 46.4 20.8 46.4 46.4v563.5c0 25.6-20.8 46.4-46.4 46.4H815.5c-25.6 0-46.4-20.8-46.4-46.4V46.4c0-25.6 20.8-46.4 46.4-46.4z"
      />
    </defs>
    <clipPath id="prefix__v">
      <use xlinkHref="#prefix__u" overflow="visible" />
    </clipPath>
    <g clipPath="url(#prefix__v)">
      <defs>
        <path id="prefix__w" d="M749-24.7h358.7v696.4H749z" />
      </defs>
      <clipPath id="prefix__x">
        <use xlinkHref="#prefix__w" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__x)">
        <path
          d="M98 0h225.9c25.6 0 46.4 20.8 46.4 46.3v563.5c0 25.6-20.8 46.3-46.4 46.3H98c-25.6 0-46.3-20.8-46.3-46.3V46.4C51.6 20.8 72.4 0 98 0zM31.5-20.1h358.7v696.4H31.5V-20.1z"
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#fff"
        />
      </g>
    </g>
    <defs>
      <path id="prefix__y" d="M24.3 44.1h270v57.7h-270z" />
    </defs>
    <clipPath id="prefix__z">
      <use xlinkHref="#prefix__y" overflow="visible" />
    </clipPath>
    <g clipPath="url(#prefix__z)" fill="#71bf44" fontFamily="Roboto-Regular" fontSize={9}>
      <text transform="translate(59.4 99.62)">P</text>
      <text transform="translate(64.47 99.62)">ARCELLE</text>
    </g>
    <defs>
      <path id="prefix__A" d="M61.8 47.9h37.5v37.5H61.8z" />
    </defs>
    <clipPath id="prefix__B">
      <use xlinkHref="#prefix__A" overflow="visible" />
    </clipPath>
    <g clipPath="url(#prefix__B)">
      <path
        d="M98.7 66.6c0 .6 0 1.2-.1 1.8-.1.6-.1 1.2-.3 1.8-.1.6-.3 1.2-.4 1.7-.2.6-.4 1.1-.6 1.7s-.5 1.1-.8 1.6-.5 1-.9 1.5c-.3.5-.7 1-1.1 1.4-.4.5-.8.9-1.2 1.3s-.9.8-1.3 1.2c-.5.4-.9.7-1.4 1.1l-1.5.9c-.5.3-1.1.5-1.6.8-.6.2-1.1.4-1.7.6s-1.1.3-1.7.4l-1.8.3c-.6.1-1.2.1-1.8.1-.6 0-1.2 0-1.9-.1-.6-.1-1.2-.1-1.8-.3-.6-.1-1.1-.3-1.7-.5s-1.1-.4-1.7-.6-1.1-.5-1.6-.8l-1.5-.9c-.5-.3-1-.7-1.4-1.1-.5-.4-.9-.8-1.3-1.2s-.8-.9-1.2-1.3c-.4-.5-.7-.9-1.1-1.4l-.9-1.5c-.3-.5-.5-1.1-.8-1.6-.2-.5-.4-1.1-.6-1.7-.2-.6-.3-1.2-.4-1.7s-.2-1.2-.3-1.8c-.1-.6-.1-1.2-.1-1.8 0-.6 0-1.2.1-1.8l.3-1.8c.1-.6.3-1.2.4-1.7.2-.6.4-1.1.6-1.7.2-.5.5-1.1.8-1.6l.9-1.5c.3-.5.7-1 1.1-1.4.4-.5.8-.9 1.2-1.3.4-.4.9-.8 1.3-1.2.5-.4.9-.7 1.4-1.1l1.5-.9c.5-.3 1.1-.5 1.6-.8.5-.2 1.1-.4 1.7-.6.6-.2 1.2-.3 1.7-.4s1.2-.2 1.8-.3c.6-.1 1.2-.1 1.8-.1.6 0 1.2 0 1.8.1l1.8.3c.6.1 1.2.3 1.7.4.6.2 1.1.4 1.7.6.6.2 1.1.5 1.6.8l1.5.9c.5.3 1 .7 1.4 1.1.5.4.9.8 1.3 1.2s.8.9 1.2 1.3c.4.5.8 1 1.1 1.5l.9 1.5c.3.5.5 1.1.8 1.6.2.5.4 1.1.6 1.7.2.6.3 1.2.4 1.7l.3 1.8c.2.6.2 1.2.2 1.8z"
        fill="none"
        stroke="#71bf44"
        strokeWidth={1.09}
        strokeMiterlimit={10}
      />
      <path
        d="M93.2 63.5l-6.1 7.6-5.6-4.3 5.4-5.6 6.3 2.3zm1.3-.3c0-.2-.2-.3-.3-.3l-7.3-2.6c-.2-.1-.4 0-.5.1l-6 6.2c-.1.1-.2.2-.1.4 0 .1.1.3.2.4l6.4 4.9c.1.1.2.1.3.1.2 0 .3-.1.4-.2l6.8-8.6c.1-.1.1-.3.1-.4zM85.6 73l-1.5 1.7-6.7-3.6 2.4-2.4 5.8 4.3zM80 67.6c-.2-.2-.5-.1-.7.1l-3.2 3.2c-.1.1-.2.2-.1.4 0 .2.1.3.3.4l7.7 4.1c.1 0 .2.1.2.1.1 0 .3-.1.4-.2l2.2-2.4c.1-.1.1-.2.1-.4 0-.1-.1-.3-.2-.4L80 67.6zm4.5-7.3l-9.4 9.4-7-3.7 11-7.5 5.4 1.8zm1.4-.3c0-.2-.2-.3-.3-.4l-6.4-2.1c-.2 0-.3 0-.4.1l-12 8.1-.2.2v.2c0 .1 0 .2.1.2 0 .1.1.1.2.2l8.1 4.3c.1 0 .2.1.2.1.1 0 .3-.1.4-.2l10.2-10.3c.1-.1.2-.2.1-.4z"
        fill="#71bf44"
      />
    </g>
    <defs>
      <path id="prefix__C" d="M24.3 68.1h37.5v.8H24.3z" />
    </defs>
    <clipPath id="prefix__D">
      <use xlinkHref="#prefix__C" overflow="visible" />
    </clipPath>
    <g clipPath="url(#prefix__D)">
      <path
        d="M59.5 68.1h2.2v.8h-2.2m-3.8-.8H58v.8h-2.2m-3.9-.8h2.2v.8H52m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.3v.8h-2.3m-3.7-.8h2.2v.8h-2.3m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8H24v.8h-2.2m-3.8-.8h2.2v.8H18m-3.8-.8h2.2v.8h-2.3m-3.7-.8h2.3v.8h-2.3m-3.7-.8H9v.8H6.7m-3.8-.8h2.2v.8H2.9m-3.8-.8h2.2v.8H-.9m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.3v.8h-2.3m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8H-16m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.3m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.3v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2"
        fill="#71bf44"
      />
    </g>
    <g>
      <defs>
        <path id="prefix__E" d="M24.3 44.1h270v57.7h-270z" />
      </defs>
      <clipPath id="prefix__F">
        <use xlinkHref="#prefix__E" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__F)" fill="#71bf44" fontFamily="Roboto-Regular" fontSize={9}>
        <text transform="translate(114.43 99.62)">CUL</text>
        <text transform="translate(129.76 99.62)">TURE</text>
      </g>
    </g>
    <g>
      <defs>
        <path id="prefix__G" d="M114.3 47.9h37.5v37.5h-37.5z" />
      </defs>
      <clipPath id="prefix__H">
        <use xlinkHref="#prefix__G" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__H)">
        <path
          d="M151.2 66.6c0 .6 0 1.2-.1 1.8-.1.6-.1 1.2-.3 1.8-.1.6-.3 1.2-.4 1.7-.2.6-.4 1.1-.6 1.7-.2.6-.5 1.1-.8 1.6l-.9 1.5c-.3.5-.7 1-1.1 1.4-.4.5-.8.9-1.2 1.3s-.9.8-1.3 1.2c-.5.4-.9.7-1.4 1.1l-1.5.9c-.5.3-1.1.5-1.6.8-.6.2-1.1.4-1.7.6-.6.2-1.1.3-1.7.4l-1.8.3c-.6.1-1.2.1-1.8.1s-1.2 0-1.8-.1-1.2-.1-1.8-.3c-.6-.1-1.2-.3-1.8-.5-.6-.2-1.1-.4-1.7-.6s-1.1-.5-1.6-.8l-1.5-.9c-.5-.3-1-.7-1.4-1.1-.5-.4-.9-.8-1.3-1.2s-.8-.9-1.2-1.3c-.4-.5-.7-.9-1.1-1.4l-.9-1.5c-.3-.5-.5-1.1-.8-1.6-.2-.5-.4-1.1-.6-1.7s-.3-1.2-.4-1.7-.2-1.2-.3-1.8c-.1-.6-.1-1.2-.1-1.8 0-.6 0-1.2.1-1.8l.3-1.8c.1-.6.3-1.2.4-1.7.2-.6.4-1.1.6-1.7.2-.5.5-1.1.8-1.6l.9-1.5c.3-.5.7-1 1.1-1.4.4-.5.8-.9 1.2-1.3.4-.4.9-.8 1.3-1.2.5-.4.9-.7 1.4-1.1l1.5-.9c.5-.3 1.1-.5 1.6-.8.5-.2 1.1-.4 1.7-.6.6-.2 1.2-.3 1.7-.4s1.2-.2 1.8-.3 1.2-.1 1.8-.1 1.2 0 1.8.1l1.8.3c.6.1 1.2.3 1.7.4.6.2 1.1.4 1.7.6.6.2 1.1.5 1.6.8l1.5.9c.5.3 1 .7 1.4 1.1.5.4.9.8 1.3 1.2.4.4.8.9 1.2 1.3.4.5.7.9 1.1 1.4l.9 1.5c.3.5.5 1.1.8 1.6.2.5.4 1.1.6 1.7.2.6.3 1.2.4 1.7l.3 1.8c.2.7.2 1.3.2 1.9z"
          fill="#71bf44"
        />
        <path
          d="M151.2 66.6c0 .6 0 1.2-.1 1.8-.1.6-.1 1.2-.3 1.8-.1.6-.3 1.2-.4 1.7-.2.6-.4 1.1-.6 1.7-.2.6-.5 1.1-.8 1.6l-.9 1.5c-.3.5-.7 1-1.1 1.4-.4.5-.8.9-1.2 1.3s-.9.8-1.3 1.2c-.5.4-.9.7-1.4 1.1l-1.5.9c-.5.3-1.1.5-1.6.8-.6.2-1.1.4-1.7.6-.6.2-1.1.3-1.7.4l-1.8.3c-.6.1-1.2.1-1.8.1s-1.2 0-1.8-.1-1.2-.1-1.8-.3c-.6-.1-1.2-.3-1.8-.5-.6-.2-1.1-.4-1.7-.6s-1.1-.5-1.6-.8l-1.5-.9c-.5-.3-1-.7-1.4-1.1-.5-.4-.9-.8-1.3-1.2s-.8-.9-1.2-1.3c-.4-.5-.7-.9-1.1-1.4l-.9-1.5c-.3-.5-.5-1.1-.8-1.6-.2-.5-.4-1.1-.6-1.7s-.3-1.2-.4-1.7-.2-1.2-.3-1.8c-.1-.6-.1-1.2-.1-1.8 0-.6 0-1.2.1-1.8l.3-1.8c.1-.6.3-1.2.4-1.7.2-.6.4-1.1.6-1.7.2-.5.5-1.1.8-1.6l.9-1.5c.3-.5.7-1 1.1-1.4.4-.5.8-.9 1.2-1.3.4-.4.9-.8 1.3-1.2.5-.4.9-.7 1.4-1.1l1.5-.9c.5-.3 1.1-.5 1.6-.8.5-.2 1.1-.4 1.7-.6.6-.2 1.2-.3 1.7-.4s1.2-.2 1.8-.3 1.2-.1 1.8-.1 1.2 0 1.8.1l1.8.3c.6.1 1.2.3 1.7.4.6.2 1.1.4 1.7.6.6.2 1.1.5 1.6.8l1.5.9c.5.3 1 .7 1.4 1.1.5.4.9.8 1.3 1.2.4.4.8.9 1.2 1.3.4.5.7.9 1.1 1.4l.9 1.5c.3.5.5 1.1.8 1.6.2.5.4 1.1.6 1.7.2.6.3 1.2.4 1.7l.3 1.8c.2.7.2 1.3.2 1.9z"
          fill="none"
          stroke="#71bf44"
          strokeWidth={1.09}
          strokeMiterlimit={10}
        />
        <path
          d="M130.3 70.1c0 1.2 1 2.3 2.2 2.3 0-.3-.1-.6-.2-.9-.1-.3-.3-.5-.5-.7s-.5-.4-.7-.5c-.2-.1-.5-.2-.8-.2zm3.2 2.3c.3 0 .6-.1.9-.2.3-.1.5-.3.7-.5s.4-.5.5-.7c.1-.3.2-.6.2-.9-1.5.2-2.4 1.1-2.3 2.3zm-.5-1.8c.2-.2.3-.4.5-.5.7-.6 1.5-.9 2.4-1 .2 0 .3-.1.4-.2l.3-.3c.2-.2.5-.2.7 0 .1.1.2.2.1.3 0 .1-.1.2-.1.3-.4.3-.6.8-.6 1.2-.1.7-.4 1.4-.9 1.9-.5.6-1.3 1-2.1 1h-.1v4.3c-.1.2-.3.3-.5.3s-.4-.1-.4-.3v-4.3c-.2 0-.5 0-.7-.1-.5-.1-.9-.3-1.3-.6s-.6-.7-.8-1.2-.3-1-.4-1.5c0-.2-.1-.4-.3-.5l-.3-.3c-.1-.1-.2-.2-.1-.4 0-.1.1-.3.1-.4.1-.1.2-.1.4-.1.1 0 .2.1.3.2.3.3.6.5 1 .6 1 .2 1.8.8 2.4 1.6zm-.5-6.3c0-1.2-.9-2.2-2.2-2.3.2 1.4 1.1 2.4 2.2 2.3zm1 0c1.1.1 2.1-.9 2.2-2.3-1.2.2-2.2 1-2.2 2.3zm-.4-6.9c-.8 1.1-.9 2.5 0 3.2.8-.8.7-2 0-3.2zm.4-1.3c0 .2 0 .5.2.6.6.8.9 1.7.9 2.7s-.5 1.8-1.3 2.4c-.1.1-.2.1-.3.1s-.2-.1-.3-.1c-.3-.2-.5-.4-.7-.7s-.3-.6-.4-.9c-.1-.3-.1-.7-.1-1s.1-.7.2-1c.2-.6.4-1.1.8-1.5.1-.1.1-.3.1-.4v-.5c0-.3.1-.5.4-.5h.1c.1 0 .3.1.4.2.1.1.1.2.1.4l-.1.2zm-3.2 9.9c-.1 1.2 1.2 2.5 2.2 2.3.2-1.1-.7-2-2.2-2.3zm5.5 0c-1.4.2-2.4 1.3-2.2 2.3 1.1.1 1.9-.8 2.2-2.3zm-2.8.6c.6-.8 1.5-1.4 2.5-1.5.4 0 .8-.2 1-.5.1-.1.2-.1.2-.2.2-.1.4 0 .5.2.1.1.2.4.1.5 0 0 0 .1-.1.1-.4.3-.6.8-.6 1.2-.1.6-.4 1.2-.7 1.7-.2.4-.6.6-.9.8-.4.2-.8.3-1.2.3h-1.5c-1 0-1.9-.7-2.4-1.6-.3-.5-.5-1.1-.6-1.8 0-.2-.1-.4-.2-.5l-.3-.3c-.1-.1-.1-.2-.1-.3 0-.1.1-.2.2-.3.1-.1.2-.1.3-.1s.2.1.3.2c.3.3.7.5 1.1.6 1 .1 1.9.6 2.4 1.5zm0-4.1c.3-.4.8-.8 1.3-1.1s1-.4 1.6-.5c.2 0 .3-.1.4-.2.1-.1.2-.3.2-.4v-4.5-.3c0-.2.2-.3.4-.3s.4.1.4.3V60.4c0 .3-.1.6-.3.8s-.4.4-.4.7c-.1.7-.4 1.4-.8 2-.3.4-.7.8-1.1 1-.5.2-1 .3-1.5.2h-.8c-.6 0-1.1-.1-1.6-.5-.5-.3-.9-.7-1.1-1.3-.2-.5-.4-1-.5-1.6 0-.2-.1-.4-.3-.5-.3-.2-.4-.6-.4-.9v-4.7c0-.1 0-.3.1-.4.1-.1.2-.2.4-.2.1 0 .3.1.4.2.1.1.1.2.1.4v4.6c0 .1.1.3.2.4.1.1.2.2.4.2.9 0 1.7.4 2.4.9.2.4.3.6.5.8z"
          fill="#fff"
        />
      </g>
    </g>
    <g>
      <defs>
        <path id="prefix__I" d="M99.3 68.1h15v.8h-15z" />
      </defs>
      <clipPath id="prefix__J">
        <use xlinkHref="#prefix__I" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__J)">
        <path
          d="M112 68.1h2.2v.8H112m-4.2-.8h2.2v.8h-2.2m-4.3-.8h2.2v.8h-2.2m-4.2-.8h2.2v.8h-2.2"
          fill="#839ca9"
        />
      </g>
    </g>
    <g>
      <defs>
        <path id="prefix__K" d="M24.3 44.1h270v57.7h-270z" />
      </defs>
      <clipPath id="prefix__L">
        <use xlinkHref="#prefix__K" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__L)" fill="#839ca9" fontFamily="Roboto-Regular" fontSize={9}>
        <text transform="translate(164.79 99.62)">PRA</text>
        <text transform="translate(181.31 99.62)">TIQUE</text>
      </g>
    </g>
    <g>
      <defs>
        <path id="prefix__M" d="M166.8 47.9h37.5v37.5h-37.5z" />
      </defs>
      <clipPath id="prefix__N">
        <use xlinkHref="#prefix__M" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__N)">
        <path
          d="M203.7 66.6c0 .6 0 1.2-.1 1.8-.1.6-.1 1.2-.3 1.8-.1.6-.3 1.2-.4 1.7-.2.6-.4 1.1-.6 1.7-.2.6-.5 1.1-.8 1.6l-.9 1.5c-.3.5-.7 1-1.1 1.4-.4.5-.8.9-1.2 1.3s-.9.8-1.3 1.2c-.5.4-.9.7-1.4 1.1l-1.5.9c-.5.3-1.1.5-1.6.8-.6.2-1.1.4-1.7.6-.6.2-1.1.3-1.7.4l-1.8.3c-.6.1-1.2.1-1.8.1s-1.2 0-1.8-.1-1.2-.1-1.8-.3c-.6-.1-1.2-.3-1.7-.4-.6-.2-1.1-.4-1.7-.6-.6-.2-1.1-.5-1.6-.8l-1.5-.9c-.5-.3-1-.7-1.4-1.1-.5-.4-.9-.8-1.3-1.2s-.8-.9-1.2-1.3c-.4-.5-.7-.9-1.1-1.4l-.9-1.5c-.3-.5-.5-1.1-.8-1.6-.2-.5-.4-1.1-.6-1.7-.2-.6-.3-1.2-.4-1.7s-.2-1.2-.3-1.8c-.1-.6-.1-1.2-.1-1.8 0-.6 0-1.2.1-1.8.1-.6.1-1.2.3-1.8s.3-1.2.4-1.7c.2-.6.4-1.1.6-1.7.2-.5.5-1.1.8-1.6l.9-1.5c.3-.5.7-1 1.1-1.4.4-.5.8-.9 1.2-1.3.4-.4.9-.8 1.3-1.2.5-.4.9-.7 1.4-1.1l1.5-.9c.5-.3 1.1-.5 1.6-.8.5-.2 1.1-.4 1.7-.6.6-.2 1.1-.3 1.7-.4l1.8-.3c.6-.1 1.2-.1 1.8-.1s1.2 0 1.8.1l1.8.3c.6.1 1.2.3 1.7.4.6.2 1.1.4 1.7.6.6.2 1.1.5 1.6.8l1.5.9c.5.3 1 .7 1.4 1.1.5.4.9.8 1.3 1.2.4.4.8.9 1.2 1.3.4.5.8.9 1.1 1.4l.9 1.5c.3.5.5 1.1.8 1.6.2.5.4 1.1.6 1.7.2.6.3 1.2.4 1.7l.3 1.8c.1.6.1 1.2.1 1.8z"
          fill="none"
          stroke="#839ca9"
          strokeWidth={1.09}
          strokeMiterlimit={10}
        />
        <path
          d="M182.7 63.2c.7 0 1.3.2 1.8.6.5.5.7 1.1.7 1.8-.7 0-1.3-.2-1.8-.6-.4-.5-.7-1.2-.7-1.8zm4.1.7c.5-.5 1.1-.7 1.8-.7 0 .7-.2 1.3-.6 1.8-.5.4-1.1.7-1.8.7 0-.7.2-1.3.6-1.8zm2.7 7h-3.3v-4.3c.9 0 1.8-.4 2.5-1 .7-.8 1-1.9.9-3 0-.1 0-.2-.1-.3s-.2-.1-.3-.1c-1.1-.1-2.1.3-2.9 1-.2.2-.3.4-.4.6-.1-.3-.3-.5-.5-.7-.8-.7-1.9-1-2.9-.9-.2 0-.4.2-.4.4-.1 1.1.3 2.1 1 2.9.7.6 1.6.9 2.5.9v4.3h-3.8c-.1 0-.3 0-.3.1-.1.1-.1.2-.1.3 0 .1 0 .3.1.4s.1.1.2.1h8c.1 0 .3 0 .3-.1.1-.1.1-.2.1-.3 0-.1-.1-.2-.1-.3-.2-.1-.4-.1-.5 0zm3.5-9.4V78h-15V61.4c0-.4.1-.9.3-1.3l1.4-2.9h11.7l1.3 2.9c.2.4.3.9.3 1.4zm-13.1-5.2v-1h11.4v1h-11.4zm13.7 3.5l-1.4-3.1v-1.9c0-.1-.1-.2-.1-.3-.1-.1-.2-.1-.3-.2h-12.3c-.2 0-.4.2-.5.4v1.9l-1.4 3.1c-.3.5-.4 1.1-.4 1.7v17c0 .1 0 .2.1.3.1.1.2.1.3.1h15.8c.1 0 .2 0 .3-.1s.1-.2.1-.3v-17c.1-.5 0-1.1-.2-1.6z"
          fill="#839ca9"
        />
      </g>
    </g>
    <g>
      <defs>
        <path id="prefix__O" d="M151.8 68.1h15v.8h-15z" />
      </defs>
      <clipPath id="prefix__P">
        <use xlinkHref="#prefix__O" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__P)">
        <path
          d="M164.5 68.1h2.2v.8h-2.2m-4.2-.8h2.2v.8h-2.2m-4.3-.8h2.2v.8H156m-4.2-.8h2.2v.8h-2.2"
          fill="#839ca9"
        />
      </g>
    </g>
    <g>
      <defs>
        <path id="prefix__Q" d="M24.3 44.1h270v57.7h-270z" />
      </defs>
      <clipPath id="prefix__R">
        <use xlinkHref="#prefix__Q" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__R)">
        <text
          transform="translate(229.84 99.62)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={9}
        >
          {'SOL'}
        </text>
      </g>
    </g>
    <g>
      <defs>
        <path id="prefix__S" d="M219.3 47.9h37.5v37.5h-37.5z" />
      </defs>
      <clipPath id="prefix__T">
        <use xlinkHref="#prefix__S" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__T)">
        <path
          d="M256.2 66.6c0 .6 0 1.2-.1 1.8-.1.6-.1 1.2-.3 1.8-.1.6-.3 1.2-.4 1.7-.2.6-.4 1.1-.6 1.7-.2.6-.5 1.1-.8 1.6l-.9 1.5c-.3.5-.7 1-1.1 1.4-.4.5-.8.9-1.2 1.3s-.9.8-1.3 1.2c-.5.4-.9.7-1.4 1.1l-1.5.9c-.5.3-1.1.5-1.6.8-.6.2-1.1.4-1.7.6-.6.2-1.1.3-1.7.4l-1.8.3c-.6.1-1.2.1-1.8.1s-1.2 0-1.8-.1-1.2-.1-1.8-.3c-.6-.1-1.2-.3-1.8-.5s-1.1-.4-1.7-.6c-.6-.2-1.1-.5-1.6-.8l-1.5-.9c-.5-.3-1-.7-1.4-1.1-.5-.4-.9-.8-1.3-1.2-.4-.4-.8-.9-1.2-1.3-.4-.5-.7-.9-1.1-1.4l-.9-1.5c-.3-.5-.5-1.1-.8-1.6-.2-.5-.4-1.1-.6-1.7-.2-.6-.3-1.2-.4-1.7s-.2-1.2-.3-1.8c-.1-.6-.1-1.2-.1-1.8 0-.6 0-1.2.1-1.8.1-.6.1-1.2.3-1.8s.3-1.2.4-1.7c.2-.6.4-1.1.6-1.7.2-.5.5-1.1.8-1.6l.9-1.5c.3-.5.7-1 1.1-1.4.4-.5.8-.9 1.2-1.3.4-.4.9-.8 1.3-1.2.5-.4.9-.7 1.4-1.1l1.5-.9c.5-.3 1.1-.5 1.6-.8.5-.2 1.1-.4 1.7-.6.6-.2 1.1-.3 1.7-.4l1.8-.3c.6-.1 1.2-.1 1.8-.1s1.2 0 1.8.1l1.8.3c.6.1 1.2.3 1.7.4.6.2 1.1.4 1.7.6.6.2 1.1.5 1.6.8l1.5.9c.5.3 1 .7 1.4 1.1.5.4.9.8 1.3 1.2.4.4.8.9 1.2 1.3.4.5.7.9 1.1 1.4l.9 1.5c.3.5.5 1.1.8 1.6.2.5.4 1.1.6 1.7.2.6.3 1.2.4 1.7l.3 1.8c.2.7.2 1.3.2 1.9z"
          fill="none"
          stroke="#839ca9"
          strokeWidth={1.09}
          strokeMiterlimit={10}
        />
        <path
          d="M233 63.1c0-.1.1-.2.2-.2h.2s.1.1.1.2 0 .1-.1.2H233.1c-.1-.1-.1-.1-.1-.2zm-.9 0c0 .3.1.5.3.7.4.4 1 .4 1.4 0 .2-.2.3-.4.3-.7s-.1-.5-.3-.7-.5-.3-.7-.3c-.3 0-.5.1-.7.3-.2.2-.3.5-.3.7zm2.2-2.3c0-.1.1-.1.2-.1h.1l.1.1c0 .1 0 .2-.1.2h-.2c-.1 0-.1-.1-.1-.2zm.2 1.1c.3 0 .5-.1.7-.3s.3-.5.3-.7c0-.3-.1-.5-.3-.7s-.5-.3-.7-.3c-.3 0-.5.1-.7.3s-.3.4-.3.7.1.5.3.7c.1.2.4.3.7.3zm.7 5l-3 .4-.8-1.4h4.5l-.7 1zm1.5-1.8h-6c-.1 0-.3.1-.4.2-.1.1-.1.3 0 .4l1.4 2.3c.1.1.2.2.4.2l3.5-.5c.1 0 .2-.1.3-.2l1.2-1.8c.1-.1.1-.3 0-.4-.1-.2-.2-.2-.4-.2zm-6.4-1.9c0-.1 0-.2.1-.2h.1c.1 0 .1 0 .1.1.1 0 .1.1.1.2-.1.1-.2.2-.3.1-.1-.1-.2-.2-.1-.2zm.2 1c.3 0 .5-.1.7-.3s.3-.5.3-.7c0-.3-.1-.5-.3-.7s-.5-.3-.7-.3c-.3 0-.5.1-.7.3s-.3.5-.3.7c0 .3.1.5.3.7s.4.3.7.3zm-.1-5.8c.1-.1.2-.1.2 0 .1 0 .1.1.1.2s-.1.2-.2.2-.2-.1-.2-.2 0-.2.1-.2zm-.9.2c0 .3.1.5.3.7s.5.3.7.3h.1c.3 0 .5-.1.7-.3.1-.1.2-.2.2-.3.1-.1.1-.3.1-.4 0-.1 0-.3-.1-.4-.1-.1-.1-.2-.2-.3-.2-.2-.5-.3-.7-.3-.1 0-.3 0-.4.1-.1 0-.2.1-.3.2-.1.1-.2.2-.2.3-.2.1-.2.3-.2.4zm6.3-.2c.1-.1.2-.1.2 0 .1 0 .1.1.1.2s-.1.2-.2.2-.2-.1-.2-.2 0-.2.1-.2zm-.9.2c0 .1 0 .3.1.4.1.1.1.2.2.3.1.1.2.2.3.2.1.1.3.1.4.1.1 0 .3 0 .4-.1.1-.1.2-.1.3-.2.1-.1.2-.2.2-.3.1-.1.1-.3.1-.4 0-.1 0-.3-.1-.4 0-.1-.1-.2-.2-.3-.1-.1-.2-.2-.3-.2-.1-.1-.3-.1-.4-.1-.1 0-.3 0-.4.1-.1.1-.2.1-.3.2-.1.1-.2.2-.2.3-.1.1-.1.3-.1.4zm.8 4.6c0-.1.1-.2.2-.2s.2.1.2.2 0 .1-.1.2H235.7v-.2zm.2 1c.3 0 .6-.1.8-.3s.3-.5.3-.7-.1-.4-.2-.6c-.1-.2-.3-.3-.5-.4-.2-.1-.4-.1-.6-.1-.2 0-.4.1-.5.3-.1.1-.2.3-.3.5-.1.4.1.8.4 1 .2.2.4.2.6.3zm-4.3-3.4c.1-.1.2-.2.3-.1l.1.1c0 .1 0 .2-.1.2-.1.1-.2.1-.2 0-.1 0-.1-.1-.1-.2zm-.8.1c0 .3.1.5.3.7s.5.3.7.3c.3 0 .5-.1.7-.3s.3-.5.3-.7c0-.4-.1-.7-.5-.8-.3-.2-.8-.2-1.1 0-.3.1-.5.4-.4.8zm-1.9-4.6c0-.1.1-.2.2-.2s.2.1.2.2 0 .1-.1.1c-.1.1-.2.1-.3-.1 0 .1 0 .1 0 0zm.2 1c.3 0 .6-.1.8-.3.4-.4.4-1.1 0-1.5-.2-.2-.5-.3-.7-.3-.3 0-.5.1-.7.3-.1.1-.2.2-.2.3-.1.2-.1.5 0 .8.1.1.1.2.2.3.1.3.3.4.6.4zm20 19.8h-2.9l-2.4-3.3 1.5-3.7 3.8 3v4zm-3.6-8c-.1-.1-.2-.1-.4-.1-.1 0-.2.1-.3.2l-1.8 4.5c-.1.1-.1.3 0 .4l2.6 3.6c.1.1.2.2.3.2h3.5c.2 0 .4-.2.4-.4V73c0-.1 0-.2-.1-.3l-4.2-3.6zm3.6 1.8l-2.7-2.2 2.7-1.9v4.1zm.6-5.3c-.1-.1-.3-.1-.4 0l-3.8 2.7c-.1.1-.2.2-.1.3 0 .1.1.2.1.3l3.8 3.1c.1.1.2.1.3.1h.1c.1-.1.2-.2.2-.4V66c.1-.2 0-.3-.2-.4zm-15 11.5h-7.9v-1.7l3.2-2.6 5.4 1.3-.7 3zm1.5-3.5c0-.1-.1-.1-.2-.2l-6-1.5c-.1 0-.3 0-.4.1l-3.5 2.8c-.1.1-.2.2-.1.3v2.3c0 .1 0 .2.1.3.1.1.2.1.3.1h8.6c.2 0 .4-.1.4-.3l.9-3.6c0-.1 0-.2-.1-.3zm-8.7-15c0-.1.1-.2.2-.2s.1 0 .1.1c.1.1.1.2 0 .3H227.5v-.2zm.2 1c.3 0 .5-.1.7-.3s.3-.5.3-.7c0-.3-.1-.5-.3-.7s-.5-.3-.7-.3c-.3 0-.5.1-.7.3-.1.1-.2.2-.2.3-.1.1-.1.3-.1.4 0 .1 0 .3.1.4 0 .1.1.2.2.3.1.2.4.3.7.3zm-.8 6.3h2.5l1.4 2.4-1.3 2.4-2.6-1.7v-3.1zm-.6 3.8l3.1 1.9c.1 0 .1.1.2.1h.1c.1 0 .2-.1.3-.2l1.6-3c.1-.1.1-.3 0-.4l-1.6-2.8c-.1-.1-.2-.2-.4-.2h-3.2c-.1 0-.2 0-.3.1s-.1.2-.1.3v3.8c0 .2.2.3.3.4zm.6 1.4l1.5.9-1.5 1.2v-2.1zm-.6 3.3h.2c.1 0 .2 0 .3-.1l2.6-2.1c.1-.1.2-.2.1-.3 0-.1-.1-.2-.2-.3l-2.6-1.6c-.1-.1-.3-.1-.4 0-.1.1-.2.2-.2.3v3.8c0 .2.1.3.2.3zm8.2-18.2c.1 0 .2 0 .2.2s0 .2-.2.2c-.1 0-.2 0-.2-.1s0-.3.2-.3c-.1 0 0 0 0 0zm-.1 1.2c.3 0 .6-.1.8-.3s.3-.4.3-.7-.1-.5-.3-.7-.5-.3-.7-.3c-.3 0-.5.1-.7.3s-.3.5-.3.7c0 .3.1.5.3.7.1.2.4.2.6.3zm8.1-1.2c.1 0 .2 0 .2.1s-.1.2-.2.2h-.1c-.1 0-.2 0-.2-.2s.2-.1.3-.1zm0 1.2c.3 0 .5-.1.7-.3s.3-.5.3-.7c0-.3-.1-.5-.3-.7s-.5-.3-.7-.3c-.4 0-.8.2-1 .6-.1.1-.1.3-.1.4 0 .1 0 .3.1.4.1.1.1.2.2.3.2.2.5.3.8.3zm1.7 5.7c.1.1.2.2.4.2s.3-.1.4-.2c.5-.7 1.3-1.1 2.2-1.2-.6.6-1.2 1.4-1.5 2.2h-2.4c-.4-1.2-1-2.3-1.9-3.2.6.1 1.2.3 1.8.7.4.4.8.9 1 1.5zm-1.7 1.6c.1.2.2.3.4.3h3.1c.2 0 .4-.1.4-.3.5-1.1 1.2-2.1 2.1-2.9.1-.1.2-.3.1-.4 0-.2-.2-.3-.4-.3-.6-.1-1.3 0-1.9.2-.6.2-1.2.5-1.6 1-1-1.5-2.7-2.3-4.5-2.1-.2 0-.3.1-.4.3-.1.2 0 .3.1.4 1.3 1 2.1 2.3 2.6 3.8zm5 1.2l-2.7 1.9-2.8-.5v-1.4h5.5zm-6.4-.7c-.1.1-.1.2-.1.3l.1 2.2c0 .2.1.4.3.4l3.4.6h.1c.1 0 .2 0 .2-.1l3.9-2.8c.2-.1.2-.3.1-.4 0-.2-.2-.3-.4-.3h-7.3c-.1 0-.2 0-.3.1zm-2.4 5l2.5-1.2 2.6.5-1.5 3.7-4.6-.4 1-2.6zm-1.7 3.4l5.5.4c.2 0 .3-.1.4-.3l1.8-4.4c.1-.1.1-.2 0-.3-.1-.1-.2-.2-.3-.2l-3.2-.6h-.3l-2.8 1.4c-.1 0-.2.1-.2.2l-1.2 3.3c-.1.1-.1.2 0 .4.1 0 .2 0 .3.1zm-1.1-1l-4.8-1.2 1.3-2.4 3.1-.4 1.5 1.2-1.1 2.8zm1.8-3.3l-1.9-1.5c-.1-.1-.2-.1-.3-.1l-3.5.5c-.1 0-.3.1-.3.2l-1.5 2.9c-.1.2 0 .4.2.5h.1l5.6 1.4h.1c.2 0 .3-.1.4-.3l1.3-3.3s-.1-.1-.2-.3zm.2-3.5h2.2v1.6l-2 1-1.2-1 1-1.6zm-1.8 2l.1.1 1.6 1.3c.1.1.2.1.3.1h.2l2.6-1.3c.1-.1.2-.2.2-.4l-.1-2.2c0-.1 0-.2-.1-.3-.1-.1-.2-.1-.3-.1h-2.8c-.1 0-.3.1-.4.2l-1.4 2.1c-.1.1-.1.2-.1.3 0 .1.1.2.2.2zm2.3-9.4h.2c.1 0 .1.1.1.2s-.1.2-.2.2h-.1c-.1 0-.2 0-.2-.1.1-.2.2-.3.2-.3zm.1 1.2c.3 0 .6-.1.8-.3s.3-.5.3-.7c0-.4-.1-.7-.5-.9-.3-.2-.8-.2-1.1 0s-.5.5-.5.8.1.5.3.7c.2.3.5.4.7.4zm8-1.2h.2c.1 0 .1.1.1.2s-.1.2-.2.2-.2 0-.2-.1v-.1c0-.1 0-.2.1-.2zm0 1.2h.2c.3 0 .5-.1.7-.3s.3-.5.3-.7c0-.3-.1-.5-.3-.7-.4-.4-1-.4-1.4 0-.2.2-.3.4-.3.7s.1.5.3.7c.1.1.3.2.5.3zm-10 17.4l.6-2.7 5.3.4 1.7 2.3h-7.6zm6.5-2.9c-.1-.1-.2-.1-.2-.1l-5.8-.4c-.2 0-.4.1-.4.3l-.8 3.5c0 .1 0 .3.1.3.1.1.2.2.3.2h8.9c.2 0 .3-.1.4-.2.1-.1.1-.3 0-.4l-2.5-3.2z"
          fill="#839ca9"
        />
      </g>
    </g>
    <g>
      <defs>
        <path id="prefix__U" d="M204.3 68.1h15v.8h-15z" />
      </defs>
      <clipPath id="prefix__V">
        <use xlinkHref="#prefix__U" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__V)">
        <path
          d="M217 68.1h2.2v.8H217m-4.2-.8h2.2v.8h-2.2m-4.3-.8h2.2v.8h-2.2m-4.2-.8h2.2v.8h-2.2"
          fill="#839ca9"
        />
      </g>
    </g>
    <g>
      <defs>
        <path id="prefix__W" d="M256.8 68.1h37.5v.8h-37.5z" />
      </defs>
      <clipPath id="prefix__X">
        <use xlinkHref="#prefix__W" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__X)">
        <path
          d="M479.5 68.1h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.3v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8H438m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.3m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.3v.8h-2.3m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.3m-3.7-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8H287m-3.8-.8h2.2v.8h-2.3m-3.7-.8h2.3v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.3m-3.8-.8h2.2v.8h-2.2m-3.8-.8h2.2v.8h-2.2m-3.7-.8h2.2v.8h-2.2"
          fill="#839ca9"
        />
      </g>
    </g>
    <g>
      <defs>
        <path id="prefix__Y" d="M304.8 762.6h-291V-24.1h291" />
      </defs>
      <clipPath id="prefix__Z">
        <use xlinkHref="#prefix__Y" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__Z)" fontFamily="Roboto-Regular">
        <text transform="translate(31.78 159.62)" fill="#71bf44" fontSize={12}>
          {'Quelle cultur'}
        </text>
        <text transform="translate(98.45 159.62)" fill="#71bf44" fontSize={12}>
          {'e a'}
        </text>
        <text transform="translate(114.21 159.62)" fill="#71bf44" fontSize={12}>
          {'v'}
        </text>
        <text transform="translate(119.95 159.62)" fill="#71bf44" fontSize={12}>
          {'ez-v'}
        </text>
        <text transform="translate(141.29 159.62)" fill="#71bf44" fontSize={12}>
          {'ous pr'}
        </text>
        <text transform="translate(174.59 159.62)" fill="#71bf44" fontSize={12}>
          {'\xE9'}
        </text>
        <text transform="translate(180.87 159.62)" fill="#71bf44" fontSize={12}>
          {'vue dans v'}
        </text>
        <text transform="translate(237.43 159.62)" fill="#71bf44" fontSize={12}>
          {'otr'}
        </text>
        <text transform="translate(252.14 159.62)" fill="#71bf44" fontSize={12}>
          {'e'}
        </text>
        <text transform="translate(31.78 173.87)" fill="#71bf44" fontSize={12}>
          {'par'}
        </text>
        <text transform="translate(48.99 173.87)" fill="#71bf44" fontSize={12}>
          {'celle'}
        </text>
        <text transform="translate(31.78 197.31)" fill="#839ca9" fontSize={9}>
          {'S\xE9lectionnez v'}
        </text>
        <text transform="translate(89.49 197.31)" fill="#839ca9" fontSize={9}>
          {'otr'}
        </text>
        <text transform="translate(100.52 197.31)" fill="#839ca9" fontSize={9}>
          {'e cultur'}
        </text>
        <text transform="translate(130.24 197.31)" fill="#839ca9" fontSize={9}>
          {'e'}
        </text>
        <text transform="translate(31.78 215.87)" opacity={0.87} fontSize={12}>
          {'B'}
        </text>
        <text transform="translate(39.38 215.87)" opacity={0.87} fontSize={12}>
          {'l'}
        </text>
        <text transform="translate(42.42 215.87)" opacity={0.87} fontSize={12}>
          {'\xE9'}
        </text>
        <text transform="translate(52 215.87)" opacity={0.87} fontSize={12}>
          {'a'}
        </text>
        <text transform="translate(58.66 215.87)" opacity={0.87} fontSize={12}>
          {'m'}
        </text>
        <text transform="translate(69.31 215.87)" opacity={0.87} fontSize={12}>
          {'\xE9'}
        </text>
        <text transform="translate(75.79 215.87)" opacity={0.87} fontSize={12}>
          {'l'}
        </text>
        <text transform="translate(78.83 215.87)" opacity={0.87} fontSize={12}>
          {'i'}
        </text>
        <text transform="translate(81.87 215.87)" opacity={0.87} fontSize={12}>
          {'o'}
        </text>
        <text transform="translate(88.85 215.87)" opacity={0.87} fontSize={12}>
          {'r'}
        </text>
        <text transform="translate(92.8 215.87)" opacity={0.87} fontSize={12}>
          {'a'}
        </text>
        <text transform="translate(99.46 215.87)" opacity={0.87} fontSize={12}>
          {'n'}
        </text>
        <text transform="translate(106.21 215.87)" opacity={0.87} fontSize={12}>
          {'t'}
        </text>
      </g>
    </g>
    <g>
      <defs>
        <path id="prefix__aa" d="M268.8 203.9h18v18h-18z" />
      </defs>
      <clipPath id="prefix__ab">
        <use xlinkHref="#prefix__aa" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__ab)">
        <path fill="#839ca9" d="M274 211.4l3.8 3.7 3.7-3.7z" />
      </g>
    </g>
    <g>
      <defs>
        <path id="prefix__ac" d="M304.8 762.6h-291V-24.1h291" />
      </defs>
      <clipPath id="prefix__ad">
        <use xlinkHref="#prefix__ac" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__ad)">
        <path fill="#839ca9" d="M31.8 223.4h255v.8h-255z" />
        <text
          transform="translate(31.78 220.37)"
          fill="#505f66"
          fontFamily="Roboto-Regular"
          fontSize={12}
        />
        <text
          transform="translate(31.78 247.56)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={9}
        >
          {'S\xE9lectionnez v'}
        </text>
        <text
          transform="translate(89.49 247.56)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={9}
        >
          {'otr'}
        </text>
        <text
          transform="translate(100.52 247.56)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={9}
        >
          {'e v'}
        </text>
        <text
          transform="translate(111.81 247.56)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={9}
        >
          {'ari\xE9t\xE9'}
        </text>
        <text
          transform="translate(31.78 266.12)"
          opacity={0.87}
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'A'}
        </text>
        <text
          transform="translate(39.74 266.12)"
          opacity={0.87}
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'M'}
        </text>
        <text
          transform="translate(50.34 266.12)"
          opacity={0.87}
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'I'}
        </text>
        <text
          transform="translate(53.73 266.12)"
          opacity={0.87}
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'C'}
        </text>
        <text
          transform="translate(61.67 266.12)"
          opacity={0.87}
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'U'}
        </text>
        <text
          transform="translate(69.58 266.12)"
          opacity={0.87}
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'S'}
        </text>
      </g>
    </g>
    <g>
      <defs>
        <path id="prefix__ae" d="M268.8 254.1h18v18h-18z" />
      </defs>
      <clipPath id="prefix__af">
        <use xlinkHref="#prefix__ae" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__af)">
        <path fill="#839ca9" d="M274 261.6l3.8 3.8 3.7-3.8z" />
      </g>
    </g>
    <g>
      <defs>
        <path id="prefix__ag" d="M304.8 762.6h-291V-24.1h291" />
      </defs>
      <clipPath id="prefix__ah">
        <use xlinkHref="#prefix__ag" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__ah)">
        <path fill="#839ca9" d="M31.8 273.6h255v.8h-255z" />
        <text
          transform="translate(31.78 270.62)"
          fill="#505f66"
          fontFamily="Roboto-Regular"
          fontSize={12}
        />
        <text
          transform="translate(31.78 333.62)"
          fill="#71bf44"
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'Quelle p\xE9riode de cultur'}
        </text>
        <text
          transform="translate(157.54 333.62)"
          fill="#71bf44"
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'e ?'}
        </text>
        <text
          transform="translate(65.53 368.12)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'2'}
        </text>
        <text
          transform="translate(71.54 368.12)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'0'}
        </text>
        <text
          transform="translate(77.55 368.12)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'1'}
        </text>
        <text
          transform="translate(83.55 368.12)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'8'}
        </text>
        <text
          transform="translate(92.27 368.12)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'-'}
        </text>
        <text
          transform="translate(98 368.12)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'2'}
        </text>
        <text
          transform="translate(104 368.12)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'0'}
        </text>
        <text
          transform="translate(110.01 368.12)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'1'}
        </text>
        <text
          transform="translate(116.02 368.12)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'9'}
        </text>
        <text
          transform="translate(65.53 405.62)"
          fill="#505f66"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'2'}
        </text>
        <text
          transform="translate(71.54 405.62)"
          fill="#505f66"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'0'}
        </text>
        <text
          transform="translate(77.55 405.62)"
          fill="#505f66"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'1'}
        </text>
        <text
          transform="translate(83.55 405.62)"
          fill="#505f66"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'9'}
        </text>
        <text
          transform="translate(92.27 405.62)"
          fill="#505f66"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'-'}
        </text>
        <text
          transform="translate(98 405.62)"
          fill="#505f66"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'2'}
        </text>
        <text
          transform="translate(104 405.62)"
          fill="#505f66"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'0'}
        </text>
        <text
          transform="translate(110.01 405.62)"
          fill="#505f66"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'2'}
        </text>
        <text
          transform="translate(116.02 405.62)"
          fill="#505f66"
          fontFamily="Roboto-Regular"
          fontSize={10.5}
        >
          {'0'}
        </text>
        <path
          d="M34 364.4c0-.7.1-1.5.2-2.2.1-.7.3-1.4.6-2.1s.6-1.3 1-1.9.8-1.2 1.3-1.7 1-1 1.6-1.4c1.1-.8 2.4-1.4 3.8-1.7 1.4-.3 2.7-.3 4.1 0 1.4.3 2.6.9 3.8 1.7.6.4 1.1.9 1.6 1.4s.9 1.1 1.3 1.7c.4.6.7 1.3 1 1.9.3.7.5 1.4.6 2.1s.2 1.5.2 2.2-.1 1.5-.2 2.2c-.1.7-.3 1.4-.6 2.1s-.6 1.3-1 2c-.4.6-.8 1.2-1.3 1.7s-1 1-1.6 1.4-1.2.7-1.8 1-1.3.5-2 .6c-1.4.3-2.7.3-4.1 0-1.3-.3-2.6-.8-3.7-1.6-.6-.4-1.1-.9-1.6-1.4-1-1.1-1.8-2.3-2.3-3.6-.3-.7-.5-1.4-.6-2.1-.2-.9-.3-1.6-.3-2.3zm-1.5 0c0-.8.1-1.7.2-2.5.2-.8.4-1.6.7-2.4s.7-1.5 1.1-2.2c.4-.7.9-1.3 1.5-1.9s1.2-1.1 1.8-1.6c.7-.5 1.3-.9 2.1-1.2.7-.3 1.5-.6 2.2-.7 1.5-.3 3.1-.3 4.7 0 .8.2 1.5.4 2.2.7.7.3 1.4.7 2.1 1.2.7.5 1.3 1 1.8 1.6.6.6 1.1 1.2 1.5 1.9.4.7.8 1.4 1.1 2.2.9 2.3 1.1 4.9.7 7.4-.3 1.6-.9 3.2-1.8 4.6-.4.7-.9 1.3-1.5 1.9-.5.6-1.2 1.1-1.8 1.6-.7.5-1.3.9-2.1 1.2-.7.3-1.5.6-2.2.7-1.5.3-3.1.3-4.7 0-.8-.2-1.5-.4-2.2-.7-.7-.3-1.4-.7-2.1-1.2-.7-.5-1.3-1-1.8-1.6-.6-.6-1.1-1.2-1.5-1.9-.4-.7-.8-1.4-1.1-2.2-.3-.8-.5-1.6-.7-2.4-.1-.8-.2-1.7-.2-2.5zM34 401.9c0-.7.1-1.5.2-2.2.1-.7.3-1.4.6-2.1s.6-1.3 1-1.9.8-1.2 1.3-1.7 1-1 1.6-1.4c1.1-.8 2.4-1.4 3.8-1.7 1.4-.3 2.7-.3 4.1 0 1.4.3 2.7.9 3.8 1.7.6.4 1.1.9 1.6 1.4s.9 1.1 1.3 1.7c.4.6.7 1.3 1 1.9.3.7.5 1.4.6 2.1s.2 1.5.2 2.2-.1 1.5-.2 2.2c-.1.7-.3 1.4-.6 2.1s-.6 1.3-1 2c-.4.6-.8 1.2-1.3 1.7s-1 1-1.6 1.4-1.2.7-1.8 1-1.3.5-2 .6c-1.4.3-2.7.3-4.1 0-1.4-.3-2.6-.8-3.8-1.6-.6-.4-1.1-.9-1.6-1.4-1-1.1-1.8-2.3-2.3-3.6-.3-.7-.5-1.4-.6-2.1-.1-.9-.2-1.6-.2-2.3zm-1.5 0c0-.8.1-1.7.2-2.5.2-.8.4-1.6.7-2.4s.7-1.5 1.1-2.2c.4-.7.9-1.3 1.5-1.9s1.2-1.1 1.8-1.6c.7-.5 1.3-.9 2.1-1.2.7-.3 1.5-.6 2.2-.7 1.5-.3 3.1-.3 4.7 0 .8.2 1.5.4 2.2.7.7.3 1.4.7 2.1 1.2.7.5 1.3 1 1.8 1.6.6.6 1.1 1.2 1.5 1.9.4.7.8 1.4 1.1 2.2.9 2.3 1.1 4.9.7 7.4-.3 1.6-.9 3.2-1.8 4.6-.4.7-.9 1.3-1.5 1.9-.5.6-1.2 1.1-1.8 1.6-.7.5-1.3.9-2.1 1.2-.7.3-1.5.6-2.2.7-1.5.3-3.1.3-4.7 0-.8-.2-1.5-.4-2.2-.7-.7-.3-1.4-.7-2.1-1.2-.7-.5-1.3-1-1.8-1.6-.6-.6-1.1-1.2-1.5-1.9-.4-.7-.8-1.4-1.1-2.2-.3-.8-.5-1.6-.7-2.4-.1-.8-.2-1.7-.2-2.5z"
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#839ca9"
        />
        <path
          d="M52.8 401.9c0 .5-.1 1.1-.2 1.6-.2 1.1-.6 2.1-1.2 3-.6.9-1.4 1.7-2.3 2.3-.9.6-1.9 1-3 1.2s-2.2.2-3.2 0c-1.1-.2-2.1-.6-3-1.2-1.8-1.2-3.1-3.1-3.5-5.2-.2-1.1-.2-2.2 0-3.2.2-1.1.6-2.1 1.2-3 .3-.5.7-.9 1.1-1.3 1.2-1.2 2.6-1.9 4.2-2.3 1.1-.2 2.2-.2 3.2 0 1.6.3 3.1 1.1 4.2 2.3.4.4.7.8 1 1.2.6.9 1 1.9 1.2 3 .2.5.3 1 .3 1.6z"
          fill="#71bf44"
        />
        <text
          transform="translate(31.78 470.87)"
          fill="#71bf44"
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'Quel est v'}
        </text>
        <text
          transform="translate(84.04 470.87)"
          fill="#71bf44"
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'otr'}
        </text>
        <text
          transform="translate(98.76 470.87)"
          fill="#71bf44"
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'e objectif de r'}
        </text>
        <text
          transform="translate(171.18 470.87)"
          fill="#71bf44"
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'endement? A'}
        </text>
        <text
          transform="translate(241.06 470.87)"
          fill="#71bf44"
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'ttention'}
        </text>
        <text
          transform="translate(31.78 485.12)"
          fill="#71bf44"
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {"l'unit\xE9 est en t/ha"}
        </text>
      </g>
    </g>
    <g>
      <defs>
        <path id="prefix__ai" d="M31.8 503.1h235.5v24H31.8z" />
      </defs>
      <clipPath id="prefix__aj">
        <use xlinkHref="#prefix__ai" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__aj)">
        <text
          transform="translate(31.78 518.87)"
          fill="#505f66"
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'5'}
        </text>
      </g>
    </g>
    <g>
      <defs>
        <path id="prefix__ak" d="M304.8 762.6h-291V-24.1h291" />
      </defs>
      <clipPath id="prefix__al">
        <use xlinkHref="#prefix__ak" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__al)">
        <text
          transform="matrix(.9707 0 -.2402 .9707 267.07 518.87)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={10.812}
        >
          {'t'}
        </text>
        <text
          transform="matrix(.9707 0 -.2402 .9707 270.61 518.87)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={10.812}
        >
          {'/'}
        </text>
        <text
          transform="matrix(.9707 0 -.2402 .9707 275.05 518.87)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={10.812}
        >
          {'h'}
        </text>
        <text
          transform="matrix(.9707 0 -.2402 .9707 280.95 518.87)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={10.812}
        >
          {'a'}
        </text>
        <path fill="#839ca9" d="M31.8 526.4h255v.8h-255z" />
        <text
          transform="translate(31.78 523.37)"
          fill="#505f66"
          fontFamily="Roboto-Regular"
          fontSize={12}
        />
        <text
          transform="translate(31.78 540.62)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={9}
        >
          {'Entr'}
        </text>
        <text
          transform="translate(47.76 540.62)"
          fill="#839ca9"
          fontFamily="Roboto-Regular"
          fontSize={9}
        >
          {'e 3 - 11 t/ha'}
        </text>
        <text
          transform="translate(31.78 601.37)"
          fill="#71bf44"
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'Quel est le d\xE9'}
        </text>
        <text
          transform="translate(103.61 601.37)"
          fill="#71bf44"
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'v'}
        </text>
        <text
          transform="translate(109.35 601.37)"
          fill="#71bf44"
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'eloppement de v'}
        </text>
        <text
          transform="translate(197.49 601.37)"
          fill="#71bf44"
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'otr'}
        </text>
        <text
          transform="translate(212.2 601.37)"
          fill="#71bf44"
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'e cultur'}
        </text>
        <text
          transform="translate(251.82 601.37)"
          fill="#71bf44"
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'e en'}
        </text>
        <text
          transform="translate(31.78 615.62)"
          fill="#71bf44"
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'sor'}
        </text>
        <text
          transform="translate(49.16 615.62)"
          fill="#71bf44"
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {"tie d'hiv"}
        </text>
        <text
          transform="translate(89.44 615.62)"
          fill="#71bf44"
          fontFamily="Roboto-Regular"
          fontSize={12}
        >
          {'er ?'}
        </text>
      </g>
    </g>
  </svg>
);

export default PhoneFR;
